<!--
 * @Author: lzz
 * @Date: 2024-06-16 00:16:29
 * @LastEditTime: 2024-07-19 01:38:33
-->
<template>
  <div class="msg-wrapper">
    <div class="msg">
      <div class="close" @click="handleClose">
        <img src="../assets/img/close4.png" alt="" />
      </div>
      <div class="list">
        <div class="item" v-for="item in msgList" @click="viewMsg(item.id)">
          <img :src="item.readStatus ? icon2 : icon1" alt="" />
          <span class="title">{{ item.templateContent }}</span>
          <span class="time">{{ formateDate(item.createTime) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import * as api from "@/api/index.js";
export default {
  data() {
    return {
      msgList: [],
      icon1: require("@/assets/img/icon71.png"),
      icon2: require("@/assets/img/icon72.png"),
    };
  },
  props: {},
  mounted() {
    this.loadMsg();
  },
  methods: {
    handleClose() {
      this.$emit("closeMsg");
    },
    formateDate(val) {
      return moment(val).format("YYYY-MM-DD");
    },
    viewMsg(id) {
      api.updataMsgRead(id).then(() => {
        this.loadMsg();
      });
      //   this.$router.push("/msgDetails?id=" + id);
    },
    loadMsg() {
      api.getMessage().then((res) => {
        this.msgList = res.data.list;
        console.log("消息", this.msgLis);
      });
    },
    handleScheduleItemChange(item) {
      this.$router.push(item.url);
    },
  },
};
</script>
<style lang="scss" scoped>
.msg-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .msg {
    width: 57vw;
    height: 25vw;
    background-size: 100% 100%;
    background-image: url("../assets/img/msg.png");
    position: relative;
    .close {
      position: absolute;
      top: -20px;
      right: -20px;
      cursor: pointer;
    }
    .list {
      width: 86%;
      height: 70%;
      margin-top: 9%;
      margin-left: 7%;
      padding: 1vw;
      overflow-y: auto;
      .item {
        display: flex;
        gap: 1vw;
        margin-bottom: 1vw;
        img {
          flex: 0 0 20px;
          vertical-align: top;
          width: 20px;
          max-height: 18px;
        }
        .title {
          flex: 1;
          color: #000;
          vertical-align: top;
          font-size: 0.93vw;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        .time {
          color: #999;
          flex: 0 0 5vw;
          vertical-align: top;
          font-size: 0.83vw;
          text-align: right;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>
